<template>
  <div>
    <p class="week-plan-help">周一00:00开始，7天×24小时，1表示开，0表示关。这里只展示计划，不会根据时间推算设备实际开关状态，也不下发修改。</p>
    <el-form-item label="显示图例"><el-switch :value="main.activeOption.showLegend !== false" @input="$set(main.activeOption, 'showLegend', $event)" /></el-form-item>
    <el-form-item label="显示摘要"><el-switch :value="main.activeOption.showSummary !== false" @input="$set(main.activeOption, 'showSummary', $event)" /></el-form-item>
    <el-form-item label="演示标识"><el-switch :value="main.activeOption.showModeLabel !== false" @input="$set(main.activeOption, 'showModeLabel', $event)" /></el-form-item>
    <el-form-item label="字体大小"><avue-input-number v-model="main.activeOption.fontSize" :min="10" :max="28" /></el-form-item>
    <el-form-item v-for="field in colors" :key="field[0]" :label="field[1]"><avue-input-color v-model="main.activeOption[field[0]]" /></el-form-item>
    <p class="week-plan-help">在数据面板中选择静态数据或设备数据。静态格式为 {"value":"168位计划"}；设备属性选择 time_table，可使用当前页面设备。</p>
  </div>
</template>
<script>
export default { inject: ['main'], data: () => ({ colors: [['color', '文字颜色'], ['onColor', '开启颜色'], ['offColor', '关闭颜色'], ['gridColor', '网格颜色'], ['backgroundColor', '背景颜色']] }) }
</script>
<style scoped>.week-plan-help{color:#a4b6c5;font-size:12px;line-height:1.6;overflow-wrap:anywhere}</style>
